export default {"src":"/stays/_next/static/media/CheckInExperience.e8b46dd3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};